import script from "./Report.vue?vue&type=script&lang=ts&setup=true"
export * from "./Report.vue?vue&type=script&lang=ts&setup=true"

import "./Report.vue?vue&type=style&index=0&id=537692bd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537692bd"]])

export default __exports__